import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            redirect: '/searchmanage'
        },
        {
            path: '/',
            component: () => import( /* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: {
                title: '自述文件'
            },
            children: [{
                    path: '/apkmanage',
                    component: () => import( /* webpackChunkName: "msgmanage" */ '../components/page/operation/Apkmanage.vue'),
                    meta: {
                        title: '安装包管理'
                    }
                },
                {
                    path: '/searchmanage',
                    component: () => import( /* webpackChunkName: "msgmanage" */ '../components/page/operation/Searchmanage.vue'),
                    meta: {
                        title: '搜索管理'
                    }
                },
                {
                    path: '/searchkeywordsmanage',
                    component: () => import( /* webpackChunkName: "msgmanage" */ '../components/page/operation/Searchkeywordsmanage.vue'),
                    meta: {
                        title: '轮播关键词管理'
                    }
                },
                {
                    path: '/editormanage',
                    component: () => import( /* webpackChunkName: "msgmanage" */ '../components/page/operation/Editormanage.vue'),
                    meta: {
                        title: '协议配置'
                    }
                },
                {
                    path: '/bannermanage',
                    component: () => import( /* webpackChunkName: "msgmanage" */ '../components/page/operation/Bannermanage.vue'),
                    meta: {
                        title: 'banner管理'
                    }
                },
                {
                    path: '/pagemanage',
                    component: () => import( /* webpackChunkName: "msgmanage" */ '../components/page/operation/Pagemanage.vue'),
                    meta: {
                        title: '发现页管理'
                    }
                },
                {
                    path: '/advertisement',
                    component: () => import( /* webpackChunkName: "msgmanage" */ '../components/page/operation/Advertisement.vue'),
                    meta: {
                        title: '广告管理'
                    }
                },
                {
                    path: '/qrcode',
                    component: () => import( /* webpackChunkName: "msgmanage" */ '../components/page/operation/Qrcode.vue'),
                    meta: {
                        title: '二维码管理'
                    }
                },
                {
                    path: '/feedbackmanage',
                    component: () => import( /* webpackChunkName: "msgmanage" */ '../components/page/operation/Feedbackmanage.vue'),
                    meta: {
                        title: '意见反馈'
                    }
                },
                {
                    path: '/newsmanage',
                    component: () => import( /* webpackChunkName: "msgmanage" */ '../components/page/operation/Newsmanage.vue'),
                    meta: {
                        title: '要闻所有分类管理'
                    }
                },
                {
                    path: '/coupon',
                    component: () => import( /* webpackChunkName: "msgmanage" */ '../components/page/operation/coupon.vue'),
                    meta: {
                        title: '优惠券管理'
                    }
                },
                {
                    path: '/activityList',
                    component: () => import( /* webpackChunkName: "msgmanage" */ '../components/page/operation/ActivityList.vue'),
                    meta: {
                        title: '活动管理'
                    }
                },
                {
                    path: '/sku',
                    component: () => import( /* webpackChunkName: "msgmanage" */ '../components/page/operation/Sku.vue'),
                    meta: {
                        title: 'SKU最低价限定'
                    }
                },
                {
                    path: '/couponExamine',
                    component: () => import( /* webpackChunkName: "msgmanage" */ '../components/page/operation/Coupon_examine.vue'),
                    meta: {
                        title: '优惠券审核'
                    }
                },
                {
                    path: '/activityListExamine',
                    component: () => import( /* webpackChunkName: "msgmanage" */ '../components/page/operation/ActivityList_examine.vue'),
                    meta: {
                        title: '活动审核'
                    }
                },
                {
                    path: '/vipManage',
                    component: () => import( /* webpackChunkName: "msgmanage" */ '../components/page/operation/vipManage.vue'),
                    meta: {
                        title: 'vip管理'
                    }
                },
                // {
                //     path: '/vip',
                //     component: () => import(/* webpackChunkName: "msgmanage" */ '../components/page/vip/viplist.vue'),
                //     meta: { title: 'VIP管理' }
                // },
                // {
                //     path: '/studiovip',
                //     component: () => import(/* webpackChunkName: "msgmanage" */ '../components/page/vip/studiovip.vue'),
                //     meta: { title: '工作室vip管理' }
                // },
                {
                    path: '/404',
                    component: () => import( /* webpackChunkName: "404" */ '../components/page/404.vue'),
                    meta: {
                        title: '404'
                    }
                },
                {
                    path: '/403',
                    component: () => import( /* webpackChunkName: "403" */ '../components/page/403.vue'),
                    meta: {
                        title: '403'
                    }
                }
            ]
        },
        {
            path: '/login',
            component: () => import( /* webpackChunkName: "login" */ '../components/page/Login.vue'),
            meta: {
                title: '登录'
            }
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
});

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}